let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dsbZs")).then(() => parcelRequire('4i9CF'));